import { SubmissionHoursConstrainType } from 'api/timesheets/configuration/submission-hours';
import { unreachable } from 'utils/unreachable';

export const getTranslationKeyForConstraintType = (
  type: SubmissionHoursConstrainType,
): string => {
  switch (type) {
    case SubmissionHoursConstrainType.IsEmpty:
      return 'empty';
    case SubmissionHoursConstrainType.LessThan:
      return 'less_than';

    case SubmissionHoursConstrainType.GreaterThan:
      return 'greater_than';

    case SubmissionHoursConstrainType.Equals:
      return 'equals';
    default:
      return unreachable(type);
  }
};
